var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "not-found-wrap" }, [
    _c("img", {
      attrs: {
        src: require("../../styles/common/img/" + _vm.imgPath + ".png"),
        alt: ""
      }
    }),
    _vm._v(" "),
    _c("div", [_vm._v(_vm._s(_vm.tip))]),
    _vm._v(" "),
    _vm.buttonText
      ? _c(
          "a",
          {
            staticClass: "not-found-btn",
            attrs: { href: "javascript:void(0)" },
            on: { click: _vm.notFoundEvt }
          },
          [_vm._v(_vm._s(_vm.buttonText))]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6a2c140a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6a2c140a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/ftNotFound.vue
// module id = null
// module chunks = 